import Logger from 'src/initializers/Logger'

export default class Event {
  constructor (type) {
    this._type = type
    this._subsribedCallbacks = []
  }
  getType () {
    return this._type
  }
  subscribe (callback) {
    if (typeof callback !== 'function') {
      Logger.error('callback must be a function')
      return false
    }
    this._subsribedCallbacks.push(callback)
    return true
  }
  trigger () {
    for (const callback in this._subsribedCallbacks) {
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/ressources/Event.js